import React, { useState, useEffect } from "react";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import ProblemStatement from "../UiElements/ProblemStatement";
import { getAnswer } from "../../helpers/wolfarmApiHandler";
import { localStore } from "../../helpers/localStorage";
import Alert from "@material-ui/lab/Alert";

function PreviewStatement() {

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  
  const fetchAnswer = async () => {
    setLoading(true);
    try {
      let ques = localStore.getProblemStatement();
      if (ques) {
        let ans = await getAnswer(ques?.asciimath);
        if(!ans){
          setError("Problem statement is not a valid maths problem.");
          setLoading(false);
          return false;
        }
        localStore.setAnswer(ans);
        setLoading(false);
      }
    } catch (err) {
      setError(err);
    }

    setLoading(false);
  };

  useEffect(() => {
    setError("");
    fetchAnswer();
  }, []);

  return (
    <>
    {error && <Alert className="error-top" severity="error">{error}</Alert>}
      <ProblemStatement />
      <div style={{ marginTop: "68px" }}>
        <Link to="/instructor/polling_responses">
          <Button
            style={{ marginTop: "10px" }}
            className="CustomButton d-block w100"
            variant="contained"
            size="large"
            disabled={loading}
          >
            Start Exercise
          </Button>
        </Link>
        <Link to="/instructor/new_exercise">
          <Button
            style={{ marginTop: "10px" }}
            className="CustomButton d-block w100"
            variant="contained"
            size="large"
            disabled={loading}
          >
            Cancel
          </Button>
        </Link>
      </div>
    </>
  );
}

export default PreviewStatement;
